var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 180,
    viewBox: "0 0 107 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.5832 0.166748H21.2499C9.97992 0.166748 0.833252 9.31342 0.833252 20.5834V159.417C0.833252 170.687 9.97992 179.833 21.2499 179.833H86.5832C97.8532 179.833 107 170.687 107 159.417V20.5834C107 9.31342 97.8532 0.166748 86.5832 0.166748ZM53.9166 171.667C47.1382 171.667 41.6666 166.195 41.6666 159.417C41.6666 152.638 47.1382 147.167 53.9166 147.167C60.6949 147.167 66.1666 152.638 66.1666 159.417C66.1666 166.195 60.6949 171.667 53.9166 171.667ZM90.6666 139H17.1666V24.6667H90.6666V139Z",
    fill: "#F2CC8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.bf8f73d6d349dfcdeff9c0fc772acbcf.svg";
export { ForwardRef as ReactComponent };